import {Box, Link, Typography} from "@mui/material";
import {Crumbs} from "../Crumbs.jsx";

const CuratorPage = () => {
    return <Box>
        <Crumbs crumbs={[
            {title: "Curator Guidance"}

        ]}>

        </Crumbs>
        <Typography variant="h6" color="textSecondary" component="p" gutterBottom>
            Curator Guidance
        </Typography>

        <Typography variant={"h6"} gutterBottom>What is a curator?</Typography>
        <Typography variant="body" color="textSecondary" component="p" gutterBottom>Curators specialize in certain areas of content and help keep user content in line with our community standards.</Typography>

        <Typography variant={"h6"} gutterBottom>How it works.</Typography>
        <Typography variant="body" color="textSecondary" component="p" gutterBottom>Curators have a completely different login at the <Link href={"https://backend.austin2step.com/admin"} target={"_blank"}>admin panel</Link>. This panel allows access to all content for that curated space. For example the playlist curator would have full control of all playlists on the site.</Typography>
        <Typography variant="body" color="textSecondary" component="p" gutterBottom>This account is completely separate from a normal user account, and has it own login. The curator account should ideally be used to modify or delete the content of others.</Typography>
        <Typography variant="body" color="textSecondary" component="p" gutterBottom>Posting content ideally would be under your normal user account. Any content posted with a curator account through the admin panel will not have any user attribution or profile attached.</Typography>

        <Typography variant={"h6"} gutterBottom>Vibe / Tone</Typography>
        <Typography variant="body" color="textSecondary" gutterBottom>We are aiming for good energy and inclusiveness. Any hateful content should be removed, negative content edited or removed.</Typography>

        <Typography variant={"h6"} gutterBottom>Privacy</Typography>
        <Typography variant="body" color="textSecondary">User data is hidden in the admin panel. Users that have submitted public content will have their public profile visible to curators but no email or private information will be visible.</Typography>

    </Box>
}

export default CuratorPage;